/**
 * EL EQUIPO DE PUX, para controles internos de la app (13-oct-2026). No hay claims ni roles de
 * personal en el sistema: es una lista de correos, la misma que tiene acceso a la cuenta de
 * diagnóstico (CLAUDE.md). Sólo decide QUÉ SE VE; los permisos de escritura los ponen las reglas
 * de Firestore, y el backend sólo acepta valores de su propia lista.
 */
export const EQUIPO_PUX = Object.freeze(['rguzman@pux.app', 'rodgum@gmail.com']);

export function esEquipoPux(user) {
  const email = String(user?.email || '').trim().toLowerCase();
  return !!email && user?.emailVerified !== false && EQUIPO_PUX.includes(email);
}
